import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-inactivity-modal',
  templateUrl: './inactivity-modal.component.html',
  styleUrls: ['./inactivity-modal.component.scss'],
})
export class InactivityModalComponent implements OnInit {
  timeLeft = 45;
  interval;

  timerStatus: 'START_NEW_ORDER' | 'TIMER_END' | 'CLOSED' = 'CLOSED';

  constructor(private dialogRef: MatDialogRef<InactivityModalComponent>) {}

  ngOnInit() {
    this.startTimer();
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 0;
        this.onYesOrNoPress('TIMER_END');
      }
    }, 1000);
  }

  closeDialog(timerStatus: 'START_NEW_ORDER' | 'TIMER_END' | 'CLOSED'): void {
    this.dialogRef.close(timerStatus);
  }

  onYesOrNoPress(timerStatus: 'START_NEW_ORDER' | 'TIMER_END' | 'CLOSED') {
    clearInterval(this.interval);
    this.closeDialog(timerStatus);
  }
}
